<!---carousel start here-->
<div id="demo" class="carousel slide container-fluid " data-bs-ride="carousel">
  <!-- Indicators/dots -->
  <div class="carousel-indicators">
    <button type="button" *ngFor="let banners of sectionImagePathList;let inVal = index" data-bs-target="#demo"
      [attr.data-bs-slide-to]="inVal" [ngClass]="{'active': inVal === 0}"></button>
  </div>
  <!-- The slideshow/carousel -->
  <div class="carousel-inner banner-height black-theme" *ngIf="color === 'bule'">
    <div class="carousel-item" *ngFor="let imglist of sectionImagePathList; let i=index"
      [ngClass]="{'active': i === 0}">

      <span [innerHTML]="imglist.Image" #scrollHere></span>
    </div>
  </div>

  <div class="carousel-inner banner-height" *ngIf="color === 'pur'">
    <div class="carousel-item" *ngFor="let imglist of sectionImagePathList; let i=index"
      [ngClass]="{'active': i === 0}">

      <span [innerHTML]="imglist.Image" #scrollHere></span>
    </div>
  </div>
  <!-- Left and right controls/icons -->
  <button class="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
    <span class="carousel-control-next-icon"></span>
  </button>
</div>
<!---carousel ends here-->


<!--- 3 Cards section start  here-->
<!-- <div class="align_bottom"  *ngIf="isDataAvailable()"> -->
<div class="align_bottom">
  <div class=" Social-mediasection">
    <div class="row row-flex ">
      <!-- Cards with media area -->
      <div id="Social-mediasection">
        <!-- Button trigger modal -->





        <mat-card>
          <span class="col-lg-12 heading" cbicTranslate="menu.OurLeadership"></span>
          <!-- <span class="col-lg-12 heading">EODB</span> -->
          <div class="example-card col-lg-12 float-start fm_list content E oDB EODB-sec-height">

            <!-- <img class="img-fluid" src="content/images/bg_eodb.jpg" alt="citizen-corner" /> -->
            <ul id="fm_List" class="leader_list custom-scr oll-bar">
              <li *ngFor="let leadershipData of ourLeadershipData" class="">
                <div class="col-lg-2 float-start image-container">
                  <img src="content/anotherfile/media/{{leadershipData.path}}" type='application/image' width="188"
                    height="207" title="Minister" alt="Avatar" class="img-fluid" />
                    <br>
                   
                  
                </div>
                <div class="col-lg-9 col-md-6 col-sm-6 float-end textcontainer">
                  <a target="_blank" href="{{leadershipData.refNumber}}"><span class="col-lg-12">
                    <cbic-static-text
                        [textEn]="leadershipData.titleEn"
                        [textHi]="leadershipData.titleHi"></cbic-static-text></span></a><br>
                        <cbic-static-text [textHi]="leadershipData.infoHi" [textEn]="leadershipData.infoEn"
                    class="small"></cbic-static-text>
                </div>

              </li>
            </ul>
          </div>
        </mat-card>

        <mat-card>
          <span class="col-lg-12 heading" cbicTranslate="menu.PhotoGallery"></span>
          <div class="example-card  float-start fm_list content">
            <div id="demo1" titleEn="" class="carousel slide" data-bs-ride="carousel" style="overflow: hidden;">
              <div class="carousel-inner carousel-inner-height position-relative">
                <!--- <div class="carousel-indicators">
                <button type="button" *ngFor="let bannersq of sectionImagePathGallaryList;let inVal = index" data-bs-target="#demo1"
                  [attr.data-bs-slide-to]="inVal" [ngClass]="{'active': inVal === 0}"></button>
                 
              </div>-->

                <div class="carousel-inner">
                  <div class="carousel-item" *ngFor="let images of newsMediaData.childContentList; let i=index"
                    [ngClass]="{'active': i === 0}">


                    <div class="carosuel-section">

                      <div #scrollHere *ngFor="let imgslist of images.cbicDocMsts;">
                        <img src="content/anotherfile/media/{{imgslist.filePathEn}}" type='application/image'
                          width="100%" />

                      </div>
                    </div>

                    <div class="carosuel-section">
                      <div *ngFor="let imgslist of images.cbicDocMsts;" [innerHTML]="imgslist.docTitleEn" #scrollHere1
                        class="carousel-caption auto custom-scroll-bar"></div>
                    </div>


                  </div>
                </div>

                <button class="carousel-control-prev" type="button" data-bs-target="#demo1" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon">
                    <img _ngcontent-hxo-c149="" src="/content/images/back-to-gallery.png" title="arrow"
                      class="img-fluid carousel-control-arrow" />
                  </span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#demo1" data-bs-slide="next">
                  <span class="carousel-control-next-icon">
                    <img _ngcontent-hxo-c149="" src="/content/images/next-to-gallery.png" title="arrow"
                      class="img-fluid carousel-control-arrow" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </mat-card>

        <mat-card *ngIf="newsAndMediaData !== null">
          <span class="col-lg-12 heading" cbicTranslate="menu.Citizen-Corner"></span>
          <div class="example-card col-lg-12 float-start fm_list content">
            <div class="citizen_corner text-center py-2">
              <!-- <div class="text-center" *ngFor="let citizens of citizensCornerList">      
                <cbic-link [linkEn]="footers.refNumber">            -->






              <cbic-link class="about-des" [linkEn]="'/entities/citizen-corner'" [linkHi]="'/entities/citizen-corner'"
                title="citizen-corner">
                <img class="img-fluid" src="content/images/citizen-corner-updated.png" alt="citizen-corner"
                 />
                <!-- <span class="citen-corner-heading">Finance Updates,Webinar & knowledge center.</span> -->

              </cbic-link>
              <!-- </div> -->
            </div>

            <!-- <div class="cbic_archives text-center"> -->
            <!-- <div class="col-12 text-center archive-container">
              </div>  -->
            <!-- <div class="col-12 text-center ">
                  <button type="button" class="btn btn-info">  -->
            <!-- <cbic-link [linkEn]="'/entities/archive-media'" [linkTextEn]="'CBIC Archives'"></cbic-link>
                    <img class="img-fluid" src="content/images/archive-64.png"> -->

            <!-- </button>
                </div> -->
            <!-- </div> -->

            <!-- <div class="col-md-12">
              <div class="bg-white shadow p-2 text-center">
                <div class="" *ngFor="let citizens of citizensCornerList">
                <img class="img-fluid" src="content/images/citizen_icon.png" alt="citizen-corner" />
                  <cbic-link class="about-des" [linkEn]="citizens.path" [linkHi]="citizens.path" [linkTextEn]="citizens.titleEn" [linkTextHi]="citizens.titleHi" title="citizen-corner"></cbic-link>
                </div>
              </div>               
            </div>

           <div class="col-12 text-center archive-container">
            <img class="img-fluid" src="content/images/archive-64.png">
          </div> 
            <div class="col-12 text-center ">
              <button type="button" class="btn btn-info"> 
                <cbic-link [linkEn]="'/entities/archive-media'" [linkTextEn]="'Go to CBIC Archives'"></cbic-link>
              </button>
            </div> -->


          </div>
        </mat-card>


      </div>
    </div>
  </div>
</div>
<!---social media section ends  here-->